import { Box } from "@chakra-ui/layout";
import { observer } from "mobx-react-lite";
import type { FunctionComponent, PropsWithChildren } from "react";

const Row: FunctionComponent<PropsWithChildren<{ id?: string }>> = observer(
  function Row({ children, id }) {
    return (
      <Box py="3" px="4">
        <div id={id} className="flex divide-x divide-skyDark pt-4 pb-6">
          {children}
        </div>
      </Box>
    );
  },
);

export default Row;
